import styled from "@emotion/styled";

import Logo from "./icon-logo-style.svg";

export const Container = styled.div``;

export const HeaderLogo = styled(Logo)`
  display: inline-block;

  inline-size: 120px;
  block-size: 75px;
  margin-block-end: 10px;

  ${props => props.theme.breakpoints.up("tablet")} {
    inline-size: 209px;
    block-size: 132px;
  }
  ${props => props.theme.breakpoints.up("desktop")} {
    inline-size: 278px;
    block-size: 176px;
  }
`;
